<template>
  <div class="Logout">
    <b-container>
      <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/logout.vue" target="_blank" style="color:black">
        <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
      </a>
      <h1>You Have Successfully logged out.</h1>
    </b-container>
  </div>
</template>

<script>
var baseUrl = 'https://frb.chimenet.ca/frb-master/'
// baseUrl = 'http://localhost:8001/'
export default {
  data () {
    return {
      baseUrl: baseUrl
    }
  },
  created () {
    delete (localStorage.accessToken)
    delete (localStorage.refreshToken)
    delete (localStorage.accessTime)
    delete (localStorage.username)
    delete (localStorage.isLogged)
    this.$router.replace(this.$route.query.redirect || '/frb-web/login')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Logout.vue